import MicroModal from 'micromodal';

MicroModal.init({
  disableScroll: true,
  disableFocus: true,
  awaitCloseAnimation: true,
  awaitOpenAnimation: true,
});